module.exports = __webpack_public_path__ + "img/modem-01.ac741aca.svg";